module.exports = __webpack_public_path__ + "img/item1-2.9162907d.jpg";